module.exports = __webpack_public_path__ + "static/bg_054_klarna_steampunk_cat-128f835cea8461fa027ef9a0ace535b3.webp";